import script from "./GestionTurnos.vue?vue&type=script&setup=true&lang=js"
export * from "./GestionTurnos.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__